// @ts-nocheck

import * as Bouncer from 'formbouncerjs'
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination,} from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const page = async () => {
    //Swiper slider
    activeSlider();
}

function activeSlider() {
    console.log('funciona');
    // swiperDetalle
    const swiper = new Swiper(".swiper", {
        slidesPerView: 1,
        loop: true,
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // when window width is >= 480px
            991: {
                slidesPerView: 2
            }
        }
    });
    
}